import React from "react";
import { Navigate } from "react-router-dom";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";


// User Profile
import UserProfile from "../pages/Authentication/user-profile";
import Variant from "../pages/Variant";
import Category from "../pages/Category";
import Specification from "../pages/Specification";
import Features from "../pages/Features";
import Brand from "../pages/Brand";
import Role from "../pages/Roles";
import Employee from "../pages/Employee";
import User from "../pages/User";
import { ViewUser } from "../pages/User/ViewUser";
import Products from "../pages/Products";
import Orders from "../pages/Orders";
import AddProduct from "../pages/Products/AddProduct";
import OrderDetail from "../pages/Orders/OrderDetail";
import DashboardEcommerce from "../pages/Dashboard";
import PlanFeatures from "../pages/Plan Features";
import Subscription from "../pages/Subscription";
import AddSubscription from "../pages/Subscription/AddSubscription";
import ChangePassword from "../pages/ChangePassword/ChangePassword";
import PlanType from "../pages/Plan Type";
import EcommerceProductDetail from "../pages/Products/ProductDetail";
import EditProduct from "../pages/Products/EditProduct";
import OrderReports from "../pages/Reports/orders";
import MonthlyOverviewReport from "../pages/Reports/monthlyOverview";

import ActivityLog from "../pages/Activity Log";
import Settings from "../pages/Settings";
import { ViewSettings } from "../pages/Settings/ViewSettings";
import AddSettings from "../pages/Settings/AddSettings";
import EditSettings from "../pages/Settings/EditSettings";
import EditSettingsKey from "../pages/Settings/EditSettingsKey";
import EditSettingsMore from "../pages/Settings/EditSettingsMore";
import CompanySettings from "../pages/Settings/CompanySettings";
import EditAppVersion from "../pages/Settings/EditAppVersion";
import Store from "../pages/Store";
import Coupon from "../pages/Coupon";
import Driver from "../pages/Driver";
import ViewCouponDetails from "../pages/Coupon/viewCouponDetails";
import ViewDriverDetails from "../pages/Driver/viewDriverDetails";
import Route from "../pages/Route";
import Delivery from "../pages/Delivery";
import { ViewDelivery } from "../pages/Delivery/ViewDelivery";
import EcommercePlanSubscription from "../pages/Plan-Subscription";
import AddPlanSubscription from "../pages/Plan-Subscription/AddPlanSubscription";
import EditPlanSubscription from "../pages/Plan-Subscription/EditPlanSubscription";
import DeliveryInstructions from "../pages/Delivery-Instructions";
import ViewPlanSubscription from "../pages/Plan-Subscription/ViewPlanSubscription";
import UserSubscriptionView from "../pages/Subscription/userSubscriptionView";
import EmployeeViewPage from "../pages/Employee/EmployeeViewPage";
import { PaymentTransactionIndex } from "../pages/Payment-Transaction";
import Banner from "../pages/Banner";
import EditSMSSettingsKey from "../pages/Settings/EditSMSSettingsKey";
import GeofenceMap from "../pages/Location/GeofenceMap";
import UndeliverableLocation from "../pages/Location/UndeliverableLocation";
import InvoiceDownload from "../pages/Orders/InvoiceDownload";
import Notifications from "../pages/Notifications/Notifications";
import VistFormBooking from "../pages/VistFormBooking";
import VisitFormBanner from "../pages/VisitFormBanner";
import AddEditSMSSetting from "../pages/Settings/SMSSettingKey/AddEditSMSSetting";
import SlotType from "../pages/SlotType";
import SubscriptionBanner from "../pages/SubscriptionBanner";




const authProtectedRoutes = [

  //Paal Dappa

  { path: "/dashboard", component: <DashboardEcommerce /> },
  { path: "/products", component: <Products /> },
  { path: "/products/add", component: <AddProduct /> },
  { path: "/plan-subscription/add", component: <AddPlanSubscription /> },
  { path: "/products/edit/:id", component: <EditProduct /> },
  { path: "/plan-subscription/edit/:id", component: <EditPlanSubscription /> },
  { path: "/plan-subscription/view/:id", component: <ViewPlanSubscription /> },
  { path: "/products/view/:id", component: <EcommerceProductDetail /> },
  { path: "/variant", component: <Variant /> },
  { path: "/category", component: <Category /> },
  { path: "/specification", component: <Specification /> },
  { path: "/features", component: <Features /> },
  { path: "/brand", component: <Brand /> },
  { path: "/banner", component: <Banner /> },
  { path: "/role", component: <Role /> },
  { path: "/employee", component: <Employee /> },
  { path: "/employee/view/:id", component: <EmployeeViewPage /> },
  { path: "/user", component: <User /> },
  { path: "/user/view/:id", component: <ViewUser /> },
  { path: "/orders", component: <Orders /> },
  { path: "/orders/view/:id", component: <OrderDetail /> },
  { path: "/order-report", component: <OrderReports /> },
  { path: "/monthly-overview-report", component: <MonthlyOverviewReport /> },

  { path: "/orders/invoice-download/:id", component: <InvoiceDownload /> },
  { path: "/plan-features", component: <PlanFeatures /> },
  { path: "/plan-type", component: <PlanType /> },
  { path: "/subscription", component: <Subscription /> },
  { path: "/subscription/add", component: <AddSubscription /> },
  { path: "/activity-log", component: <ActivityLog /> },
  { path: "/settings", component: <Settings /> },
  { path: "/settings/add", component: <AddSettings /> },
  { path: "/settings/edit/:id", component: <EditSettings /> },
  { path: "/settings/view/:id", component: <ViewSettings /> },
  { path: "/settings/editkey/:id", component: <EditSettingsKey /> },
  { path: "/settings/edit-sms-key/:id", component: <EditSMSSettingsKey /> },
  { path: "/settings/sms-setting/add", component: <AddEditSMSSetting /> },
  { path: "/settings/sms-setting/edit/:id", component: <AddEditSMSSetting /> },
  { path: "/settings/editmore/:id", component: <EditSettingsMore /> },
  { path: "/settings/company/:id", component: <CompanySettings /> },
  { path: "/settings/app-version/edit/:id", component: <EditAppVersion /> },
  { path: "/store", component: <Store /> },
  { path: "/delivery-instruction", component: <DeliveryInstructions /> },
  { path: "/driver", component: <Driver /> },
  { path: "/coupon", component: <Coupon /> },
  { path: "/coupon/view/:id", component: <ViewCouponDetails /> },
  { path: "/driver/view/:id", component: <ViewDriverDetails /> },
  { path: "/route", component: <Route /> },
  { path: "/delivery", component: <Delivery /> },
  { path: "/payment-transactions", component: <PaymentTransactionIndex /> },
  { path: "/delivery/view/:id", component: <ViewDelivery /> },
  { path: "/plan-subscription", component: <EcommercePlanSubscription /> },
  { path: "/view-user-subscription/:id", component: <UserSubscriptionView /> },
  { path: "/notifications", component: <Notifications /> },
  { path: "/vist-form-booking", component: <VistFormBooking /> },
  { path: "/visit-form-banner", component: <VisitFormBanner /> },
  { path: "/slot-type", component: <SlotType /> },
  { path: "/subscription-banner", component: <SubscriptionBanner /> },



  { path: "/location", component: <GeofenceMap /> },
  { path: "/unavailable-location", component: <UndeliverableLocation /> },

  //User Profile
  { path: "/profile", component: <UserProfile /> },
  { path: "/change-password", component: <ChangePassword /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };